/**
 * Top-of-page banner shown when an admin/agent is in "view as vendor" mode.
 * Renders nothing when not impersonating. Click "Exit" to clear the header
 * and reload the page back into the admin's own identity.
 */
import { Eye, X } from "lucide-react";
import { getViewAsVendor, getViewAsLabel, setViewAsVendor } from "@/lib/api";

export default function ImpersonationBanner() {
  const id = getViewAsVendor();
  if (!id) return null;
  const label = getViewAsLabel();
  return (
    <div
      className="sticky top-0 z-50 bg-amber-500 text-amber-950 text-xs sm:text-sm flex items-center justify-between gap-3 px-3 py-1.5 border-b border-amber-600 shadow-sm"
      data-testid="impersonation-banner"
    >
      <div className="flex items-center gap-2 min-w-0">
        <Eye className="h-3.5 w-3.5 shrink-0" />
        <span className="font-semibold truncate">
          Viewing as {label || id}
        </span>
        <span className="hidden sm:inline opacity-80">— full access · cannot delete vehicles or disconnect Stripe</span>
      </div>
      <button
        type="button"
        onClick={() => setViewAsVendor(null)}
        className="inline-flex items-center gap-1 rounded-full bg-amber-950 text-amber-50 px-2.5 py-0.5 hover:bg-amber-900 shrink-0"
        data-testid="impersonation-exit"
      >
        <X className="h-3 w-3" /> Exit
      </button>
    </div>
  );
}
